import TitledContainer from 'components/ui/TitledContainer/TitledContainer'
import { useInvoiceUpload } from 'services/invoice/api/request'
import { Upload } from 'components/ui/Upload/Upload'

import './invoice.style.css'

export const Invoice = () => {
  const { isLoading, call: invoiceUpload } = useInvoiceUpload()

  const handleSubmit = async (file: File) => {
    await invoiceUpload(file)
  }

  const renderHint = () => (
    <span className="invoice-upload-hint">Для отправки подойдут PDF файлы, размером до 10мб</span>
  )

  return (
    <div className="invoice-upload-container">
      <TitledContainer title="Отправка квитанции">
        <div className="invoice-upload-wrapper">
          <Upload loading={isLoading} onSubmit={handleSubmit} hint={renderHint()} />
        </div>
      </TitledContainer>
    </div>
  )
}
